import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');

function ClientProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [notes, setNotes] = useState([]);
  const [zoneName, setZoneName] = useState('');
  const [error, setError] = useState('');
  const [isLoadingNotes, setIsLoadingNotes] = useState(true);

  const fetchData = async () => {
    try {
      setIsLoadingNotes(true);
      const [profileRes, notesRes] = await Promise.all([
        fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/patients/${id}/profile`),
        fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/patients/${id}/notes`)
      ]);

      const profileData = await profileRes.json();
      const notesData = await notesRes.json();

      setProfile(profileData);
      setNotes(notesData);
      setIsLoadingNotes(false);

      if (profileData.zone_id) {
        const zoneRes = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/zones/${profileData.zone_id}`);
        const zoneData = await zoneRes.json();
        setZoneName(zoneData.name || profileData.zone_id);
      }

    } catch (err) {
      console.error('❌ Erreur chargement profil :', err);
      setError('Erreur de chargement du profil.');
      setIsLoadingNotes(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  if (error) {
    return (
      <div style={{ color: 'white', backgroundColor: 'red', padding: '10px', borderRadius: '6px' }}>
        {error}
      </div>
    );
  }

  if (!profile) {
    return <p>Chargement du profil...</p>;
  }

  return (
    <div style={{ padding: '2rem' }}>
      <button
        onClick={() => navigate('/professional/clients')}
        style={{
          marginBottom: '1rem',
          backgroundColor: '#ddd',
          border: 'none',
          padding: '8px 12px',
          cursor: 'pointer',
          borderRadius: '6px'
        }}
      >
        ⬅️ Retour à la liste des clients
      </button>

      <h2>Profil de {profile.first_name} {profile.last_name}</h2>

      <table
        style={{
          borderCollapse: 'collapse',
          width: '100%',
          marginBottom: '2rem'
        }}
        border="1"
        cellPadding="8"
      >
        <tbody>
          <tr><td><strong>Email</strong></td><td>{profile.email || 'Non renseigné'}</td></tr>
          <tr><td><strong>Téléphone</strong></td><td>{profile.phone || 'Non renseigné'}</td></tr>
          <tr><td><strong>Date de naissance</strong></td><td>{profile.birth_date ? moment(profile.birth_date).format('DD/MM/YYYY') : 'Non renseignée'}</td></tr>
          <tr><td><strong>Zone géographique</strong></td><td>{zoneName || 'Non renseignée'}</td></tr>
        </tbody>
      </table>

      <div style={{ marginBottom: '1rem' }}>
        <button
          onClick={() => navigate(`/professional/clients/${id}/add-note`)}
          style={{
            backgroundColor: '#1e88e5',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          ➕ Ajouter une note au dossier
        </button>
      </div>

      <h3>📝 Notes au dossier ({notes.length})</h3>

      {isLoadingNotes ? (
        <p>Chargement des notes...</p>
      ) : notes.length === 0 ? (
        <p>Aucune note au dossier.</p>
      ) : (
        <ul style={{ paddingLeft: '0', listStyle: 'none' }}>
          {notes.map(note => (
            <li key={note.note_id} style={{
              border: '1px solid #ccc',
              padding: '10px',
              borderRadius: '8px',
              marginBottom: '10px',
              backgroundColor: '#f9f9f9'
            }}>
              <div>
                <strong>{moment(note.created_at).format('DD/MM/YYYY')} :</strong> {note.content}
              </div>
              {note.appointment_id && (
                <div style={{ color: '#555' }}>
                  <em>(Note liée à un rendez-vous)</em>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ClientProfile;